import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import type { AgentItemApiDto } from "@/Modules/Agent/Models/Api";
import type { AgentItem } from "@/Modules/Agent/Models/Domain";

import { camel } from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const AnswerTransformer: TransformerExtended<AgentItem, AgentItemApiDto> = {
  ...DefaultTransformerGenerator<AgentItem, AgentItemApiDto>(),

  toDomain(input: AgentItemApiDto) {
    return camel<AgentItemApiDto, AgentItem>(input);
  },
};

export type AnswerTransformerType = TransformerExtended<AgentItem, AgentItemApiDto>;

export default AnswerTransformer;
